import React, { useEffect, useState } from "react";
import OrderSummary from "./orderSummary";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const CartPrice = ({ page, cartPriceButton, totalCartAmount, items, loading }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [totalAfterDelivery, setTotalAfterDelivery] = useState(0);
  const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [couponMsg, setCouponMsg] = useState("");
  const [couponMsgColor, setCouponMsgColor] = useState("red");
  const [totalQuantity, setTotalQuantity] = useState(0);
  const deliveryCharges = 100;

  useEffect(() => {
    if (totalCartAmount > 1999) {
      setTotalAfterDelivery(totalCartAmount);
    } else {
      setTotalAfterDelivery(totalCartAmount + deliveryCharges);
    }
  }, [totalCartAmount]);

  useEffect(() => {
    setTotalAfterDiscount(totalAfterDelivery);
    if (items) {
      let qyn = 0;
      items.map((item) => {
        qyn = qyn + item.quantity;
      });
      setTotalQuantity(qyn);
    }
  }, [totalAfterDelivery]);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleApplyCoupon = () => {
    const coupons = {
      STITCHD10: 10,
      STITCHD20: 20,
      ROHIT69: 69,
    };

    if (couponCode === "STITCHD20" && totalQuantity <= 1) {
      setDiscount(0);
      setCouponMsg("STITCHD20 coupon requires at least 2 items in the cart");
      setCouponMsgColor("red");
      return;
    }

    if (coupons[couponCode]) {
      const discountAmount = Math.ceil(
        (totalAfterDelivery * coupons[couponCode]) / 100
      );
      setDiscount(discountAmount);
      setTotalAfterDiscount(totalAfterDelivery - discountAmount);
      if (couponCode === "ROHIT69") {
        setCouponMsg(`Congrats! You get Rohit's special discount`);
      } else {
        setCouponMsg(`Congrats! You save ${coupons[couponCode]}% on this order`);
      }
      setCouponMsgColor("green");
    } else {
      setDiscount(0);
      setCouponMsg("Invalid coupon code");
      setCouponMsgColor("red");
    }
  };

  return (
    <div className="rounded shadow-sm font-twentieth-century md:mt-20 mt-10 md:ml-4 relative">
      {page !== "Payment" && (
        <div>
          <h3 className="text-lg font-semibold mb-4 text-center mt-2">
            Cart Price
          </h3>

          {page !== "Checkout" && (
            <div className="flex justify-center items-center border-2 p-3 border-red-500">
              <button
                className="text-red-500 text-sm font-semibold"
                onClick={openModal}
              >
                VIEW ORDER SUMMARY
              </button>
            </div>
          )}

          <div className="border p-4 pb-24 md:pb-4">
            {loading ? (
              <>
                <Skeleton height={30} width={150} className="mb-2" />
                <Skeleton height={30} width={150} className="mb-2" />
                <Skeleton height={30} width={150} className="mb-2" />
              </>
            ) : (
              <>
                <div className="flex justify-between mb-2">
                  <span className="w-20">Item Total:</span>
                  <span className="ml-48">₹{totalCartAmount}</span>
                </div>
                <div className="flex justify-between mb-2">
                  <span>Delivery Charges:</span>
                  <div>
                    {totalCartAmount < 2000 ? (
                      <span>₹{deliveryCharges}</span>
                    ) : (
                      <div className="flex">
                        <p className="line-through">₹{deliveryCharges}</p>
                        <p className="text-red-600">Free Delivery</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex justify-between mb-2">
                  <span>Discount:</span>
                  <span>-₹{discount}</span>
                </div>
              </>
            )}

            <div className="mb-4">
              <div className="h-px w-full bg-gray-200 my-6"></div>
              {page === "Checkout" && (
                <div className="flex items-center">
                  <input
                    type="text"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    placeholder="Enter coupon code"
                    className="border p-2 w-full rounded"
                    disabled={loading}
                  />
                  <button
                    className="bg-green-600 text-white p-2 rounded ml-2 hover:bg-green-600"
                    onClick={handleApplyCoupon}
                    disabled={loading}
                  >
                    Apply
                  </button>
                </div>
              )}
              {couponMsg && (
                <p
                  className={`mt-2 ${
                    couponMsgColor === "green"
                      ? "text-green-500"
                      : "text-red-500"
                  }`}
                >
                  {couponMsg}
                </p>
              )}
              <div className="h-px w-full bg-gray-200 my-6"></div>
            </div>
            {!loading && (
              <div className="flex justify-between font-semibold mb-4 text-lg md:hidden">
                <span>Total Amount:</span>
                <span>₹{totalAfterDiscount}</span>
              </div>
            )}
          </div>

          {/* for mobile screen */}
          <div className="fixed bottom-0 left-0 w-full bg-white p-2 flex justify-between items-center shadow-top md:hidden">
            <div className="flex flex-col ml-4">
              <span>Total Amount:</span>
              {loading ? (
                <Skeleton height={20} width={100} />
              ) : (
                <span className="font-semibold text-lg">
                  ₹{totalAfterDiscount}
                </span>
              )}
            </div>
            <button
              className="bg-red-500 text-white p-2 rounded hover:bg-red-600 text-lg w-36 mr-2 text-center"
              onClick={() => cartPriceButton(totalAfterDiscount)}
              disabled={loading}
            >
              {page}
            </button>
          </div>

          {/* for big screens */}
          <div className="hidden md:block">
            <div className="flex justify-between font-semibold mb-4 text-lg">
              <span>Total Amount:</span>
              {loading ? (
                <Skeleton height={20} width={100} />
              ) : (
                <span>₹{totalAfterDiscount}</span>
              )}
            </div>
            {page === "Checkout" && (
              <button
                className="bg-red-500 text-white p-2 w-full rounded hover:bg-red-600 text-lg"
                onClick={() => cartPriceButton(totalAfterDiscount)}
                disabled={loading}
              >
                {page}
              </button>
            )}
          </div>
        </div>
      )}

      {page === "Payment" && (
        <div className="fixed bottom-0 left-0 w-full bg-white p-2 flex justify-between items-center shadow-top md:hidden">
          <button
            className="bg-red-500 w-full text-white p-2  hover:bg-red-600 text-lg text-center"
            onClick={openModal}
          >
            VIEW ORDER SUMMARY
          </button>
        </div>
      )}

      <OrderSummary
        onClose={closeModal}
        items={items}
        isOpen={modalIsOpen}
        totalCartAmount={totalCartAmount}
        totalAfterDelivery={totalAfterDelivery}
        totalAfterDiscount={totalAfterDiscount}
      />
    </div>
  );
};

export default CartPrice;
